export default 'M12 24a12 12 0 1 0 0-24 12 12 0 0 0 0 24M8 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0m10 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0';